import * as _ from 'lodash';
import {Injectable} from "@angular/core";

@Injectable()
export class CompetenceProvider {
    competences = [
        {code: 1, label: 'Janeiro'},
        {code: 2, label: 'Fevereiro'},
        {code: 3, label: 'Março'},
        {code: 4, label: 'Abril'},
        {code: 5, label: 'Maio'},
        {code: 6, label: 'Junho'},
        {code: 7, label: 'Julho'},
        {code: 8, label: 'Agosto'},
        {code: 9, label: 'Setembro'},
        {code: 10, label: 'Outubro'},
        {code: 11, label: 'Novembro'},
        {code: 12, label: 'Dezembro'},
    ]

    find(competencesCode) {
        const competence = this.competences.filter(competences => competences.code == competencesCode);

        if (_.isEmpty(status))
            throw 'Competência inválida';

        return competence;
    }

    findCompetence(competencesCode) {
        const competence = this.competences.find(competences => competences.code == competencesCode);
        return competence ? competence.label : '';
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/enums/billing-letter/competence-provider.ts